// definir un objeto mixin
var MpSessionLogin = {
    created: function () {},
    data: function() {
        return {
            FORM_URL: '/session/login',

            RESPONSE_OK: 'OK',
            RESPONSE_KO: 'KO',

            STATUS_MAX_SESSIONS: 'max_concurrent_sessions_error',
            STATUS_UNIQUE_SESSION: 'users_logged_on_session_unique',
            STATUS_CAPTCHA_REQUIRED: 'captcha_required',
            STATUS_CAPTCHA_ERROR: 'captcha_error',
            STATUS_ADD_USERS: 'require_add_users',

            REDIRECTION_BASE: '/private/home',
            REDIRECTION_EQUIPMENT: '/equipment/new',

            VALIDATION_OK: 1,
            VALIDATION_KO: 0,

            user: '',
            passwd: '',
            hasCaptcha: false,
            captcha: '',
            referer: '',
            scope: '',

            errors: [],
            successMessage: '',
            validated: false,
        };
    },
    computed: {

        userCheck: function() {
            return !this.validated || !FormValidator.isEmpty(this.user);
        },

        passwdCheck: function() {
            return !this.validated || !FormValidator.isEmpty(this.passwd);
        },

        captchaCheck: function() {
            return !this.hasCaptcha || !this.validated || !FormValidator.isEmpty(this.captcha);
        },

    },
    methods: {

        cleanErrors: function() {
            this.errors = [];
         },

         addError: function(errorMsg) {
             if (this.errors.length > 0) {
                 return;
             }

             this.errors.push(errorMsg);
         },

         validateForm: function() {
             /// error_data is globally injected from PHP controller
             var isValid = true;

             this.cleanErrors();
             this.validated = true;

             if (!this.userCheck) {
                 this.addError(error_data);
                 isValid = false;
             }

             if (!this.passwdCheck) {
                 this.addError(error_data);
                 isValid = false;
             }

             if (!this.captchaCheck) {
                this.addError(error_data);
                isValid = false;
            }

             return isValid;
         },

         onSend: function(response) {
             var redirectUrl;

             if (response.data.result === this.RESPONSE_KO) {

                switch (response.data.status) {
                    case this.STATUS_MAX_SESSIONS:
                        redirectUrl = '/session/user/' + response.data.user + '/lang/' + response.data.lang;
                    break;

                    case this.STATUS_UNIQUE_SESSION:
                        redirectUrl = '/session/unique?user=' + response.data.user;
                    break;

                    case this.STATUS_CAPTCHA_ERROR:
                        redirectUrl = '/session/login?captcha=true' + ((response.data.redirect) ? '&referer=' + response.data.redirect : '');
                    break;

                    case this.STATUS_CAPTCHA_REQUIRED:
                        redirectUrl = '/session/login?captcha=true&referer=' + response.data.redirect;
                    break;

                    case this.STATUS_ADD_USERS:
                        redirectUrl = '/session/users-add';
                    break;
                }

                if (redirectUrl) {
                    window.location = redirectUrl;
                    return;
                } else {
                    this.addError(response.data.message);
                    return;
                }
             }

             redirectUrl = response.data.redirect;

             if (!redirectUrl) {
                 redirectUrl = (this.scope === 'equipment') ? this.REDIRECTION_EQUIPMENT : this.REDIRECTION_BASE;
             }

             window.location.href = redirectUrl;
             return;
         },

         sendForm: function(ev) {
             if (this.validateForm()) {
                 axios
                     .post(this.FORM_URL,
                         this.dataSend,
                         { headers: { 'X-Requested-With': 'XMLHttpRequest' } }
                     )
                     .then(this.onSend)
                     .catch(function(error) {
                         console.log(error);
                     });
             }
         },
    },

    mounted: function() {
        this.referer = this.$refs.referer.value;
    }
};
